var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"p-2 d-flex",attrs:{"variant":"primary"},on:{"click":_vm.logout}},[_c('logout',{staticClass:"align-self-center",attrs:{"title":""}}),_c('p',{staticClass:"m-0 align-self-center"},[_vm._v("Cerrar Sesión")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }